



























import { TopUpDeal } from '@/utils/interfaces/topup.interface'
import Vue, { PropType } from 'vue'
import DealCard from '~/components/Dashboard/DealCard.vue'
export default Vue.extend({
  components: { DealCard },
  props: {
    deals: Array as PropType<TopUpDeal[]>,
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
  },
})
